export enum EmployeeGradeType {
  Cadre,
  NoCadre,
}

export const EmployeeGradeTypeOptions = [
  { id: EmployeeGradeType.Cadre, name: 'Cadre' },
  { id: EmployeeGradeType.NoCadre, name: 'NoCadre' },
];
